import { print } from "graphql";
import { SebraeCarro } from "@/models/sebraeCarro";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map, catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import GlobalStore from "@/store/modules/global";

const veiculo = require("@/query/rota-emocoes/SebraeCarro.graphql");

export class SebraeCarroAPI extends BaseAPI<SebraeCarro> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/veiculo`;
  }

  public findBy(
    placa: string,
    recaptcha: string
  ): AxiosObservable<SebraeCarro> {
    placa = placa.replace("-", "");

    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(veiculo),
        variables: { placa, recaptcha }
      })
      .pipe(
        catchError(error => {
          GlobalStore.setSnackBar({
            message: error.exception.message,
            show: true,
            type: "error"
          });
          return throwError(error);
        })
      )
      .pipe(
        map((data: any) => {
          const { veiculo } = data;
          return veiculo;
        })
      );
  }
}
